import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { loadRuntimeConfig, ConfigProvider } from "@/utils/runtimeConfig";

// Load runtime config from backend, then render
loadRuntimeConfig().then(() => {
  const root = ReactDOM.createRoot(document.getElementById("root"));
  root.render(
    <React.StrictMode>
      <ConfigProvider>
        <App />
      </ConfigProvider>
    </React.StrictMode>,
  );
});
